<template>
  <label class="check" :class="{path: outlined, bounce: !outlined}" :for="id">
    <input type="checkbox" ref="inp" v-model="checked" :checked="checked" :id="id" style="min-width: 21px; min-height: 21px" @change="$emit('change')">
    <svg viewBox="0 0 21 21" style="min-width: 21px; min-height: 21px">
      <path v-if="outlined" d="M5,10.75 L8.5,14.25 L19.4,2.3 C18.8333333,1.43333333 18.0333333,1 17,1 L4,1 C2.35,1 1,2.35 1,4 L1,17 C1,18.65 2.35,20 4,20 L17,20 C18.65,20 20,18.65 20,17 L20,7.99769186"></path>
      <polyline v-if="!outlined" points="5 10.75 8.5 14.25 16 6"></polyline>
    </svg>
    <div class="title">
        <slot/>
      </div>
  </label>
</template>

<script>
export default {
  name: 'custom-checkbox',
  props: {
    outlined: {
      type: Boolean,
      default: false
    },
    id: String,
    name: String,
    value: [Number, Boolean, String],
    color: {
      type: String,
      default: '#FFD2B4'
    },
  },
  mounted() {
    this.$refs.inp.style.setProperty('--border', this.color);
    this.$refs.inp.style.setProperty('--border-active', this.color);
  },
  watch: {
    checked(val, from) {
      if (val !== from) this.$emit('change', val);
      this.$emit('input', val);
    }
  },
  data() {
    return {
      checked: this.value,
    }
  }
}
</script>

<style scoped lang="scss">
.check {
  cursor: pointer;
  --border: #D1D6EE;
  --border-hover: #7a7a7a;
  --border-active: #1E2235;
  --tick: #383838;
  position: relative;
  display: flex;
  align-items: center;

  .title {
    width: calc(100% - 31px);
    margin-left: 10px;
    font-family: "Open Sans", sans-serif;
    font-size: 16px;
    line-height: 1;
    color: #383838;
  }

  input, svg {
    width: 21px;
    height: 21px;
    display: block;
  }

  input {
    -webkit-appearance: none;
    -moz-appearance: none;
    position: relative;
    outline: none;
    background: transparent;
    border: none;
    margin: 0;
    padding: 0;
    cursor: pointer;
    border-radius: 4px;
    transition: box-shadow .3s;
    box-shadow: inset 0 0 0 var(--s, 1px) var(--b, var(--border));

    &:hover {
      --s: 2px;
      --b: var(--border-hover);
    }

    &:checked {
      --b: var(--border-active);
    }
  }

  svg {
    pointer-events: none;
    fill: none;
    stroke-width: 2px;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke: var(--stroke, var(--border-active));
    position: absolute;
    top: 0;
    left: 0;
    width: 21px;
    height: 21px;
    transform: scale(var(--scale, 1)) translateZ(0);
  }

  &.path {
    input {
      &:checked {
        --s: 2px;
        transition-delay: .4s;

        & + svg {
          --a: 16.1 86.12;
          --o: 102.22;
        }
      }
    }

    svg {
      stroke-dasharray: var(--a, 86.12);
      stroke-dashoffset: var(--o, 86.12);
      transition: stroke-dasharray .6s, stroke-dashoffset .6s;
    }
  }

  &.bounce {
    --stroke: var(--tick);

    input {
      &:checked {
        --s: 11px;

        & + svg {
          animation: bounce .4s linear forwards .2s;
        }
      }
    }

    svg {
      --scale: 0;
    }
  }
}

@keyframes bounce {
  50% {
    transform: scale(1.2);
  }
  75% {
    transform: scale(.9);
  }
  100% {
    transform: scale(1);
  }
}
</style>
